import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';

import ModalBase from '../ModalBase/ModalBase';
import Button from '../Button/Button';
import useFirebase from '../../../services/firebase/useFirebase';
import { logOut as clearSession } from '../../../services/auth';
import { withTimeout } from '../../../utils/network';

const ModalLogOut = ({ isOpen, setIsOpen }) => {
    const firebase = useFirebase();

    function closeModal() {
        setIsOpen(false);
    }

    const handleLogout = () => {
        const logoutFromFirebase = async () => {
            try {
                await withTimeout(firebase.auth().signOut());
                console.log('User signed out from Firebase');
            } catch (error) {
                console.error('Error signing out from Firebase:', error);
            }
        };

        const logOut = async () => {
            clearSession();
            await logoutFromFirebase();
        };

        logOut().then(() => {
            closeModal();
            navigate('/?logout=true');
        });
    };

    return (
        <ModalBase modalIsOpen={isOpen} closeModal={() => closeModal()}>
            <>
                <h2>
                    Voulez vous vraiment vous déconnecter de l&apos;application
                    ?
                </h2>
                <div>
                    <Button
                        action={() => handleLogout()}
                        text='Se déconnecter'
                    />
                    <Button
                        action={() => closeModal()}
                        isFilled
                        text='Annuler'
                    />
                </div>
            </>
        </ModalBase>
    );
};

ModalLogOut.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
};

export default ModalLogOut;
